import Vue from 'vue';

import auth from './auth';
import helpers from './helpers';

Vue.mixin(auth);
Vue.mixin(helpers);


// WEBPACK FOOTER //
// ./src/mixins/index.js